<template>
  <div class="page form-page">
    <PageTitle :title="title"></PageTitle>
    <div class="app-container">
      <slot></slot>
    </div>
    <NeedHelp></NeedHelp>
  </div>
</template>
<script>
import PageTitle from '@/components/header/PageTitle.vue';
import NeedHelp from '@/components/commons/NeedHelp.vue';

export default {
  components: {
    PageTitle,
    NeedHelp,
  },

  data() {
    return {
      title: this.$route.meta.title,
    };
  },
};
</script>
<style lang="scss">
.form-page {
  .app-container {
    padding-top: 20px;
  }
}
</style>
